//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.18.2.0 (NJsonSchema v10.8.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import axios, { AxiosError } from "axios";
import type { AxiosInstance, AxiosRequestConfig, AxiosResponse, CancelToken } from "axios";

export interface IBetalingsregelingAanvragenEndpointClient {
  /**
   * @param body (optional)
   * @return Success
   */
  betalingsregelingAanvragen(
    body?: BetalingsregelingAanvragenCommand | undefined
  ): Promise<KlantContactResponse>;
}

export class BetalingsregelingAanvragenEndpointClient implements IBetalingsregelingAanvragenEndpointClient {
  private instance: AxiosInstance;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(baseUrl?: string, instance?: AxiosInstance) {
    this.instance = instance ? instance : axios.create();

    this.baseUrl =
      baseUrl !== undefined && baseUrl !== null
        ? baseUrl
        : "/Service/HetCak.OpenCak.KlantOndersteuning.Service";
  }

  /**
   * @param body (optional)
   * @return Success
   */
  betalingsregelingAanvragen(
    body?: BetalingsregelingAanvragenCommand | undefined,
    cancelToken?: CancelToken | undefined
  ): Promise<KlantContactResponse> {
    let url_ = this.baseUrl + "/eb/klantondersteuning/api/v1/klantcontact/betalingsregeling-aanvragen";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processBetalingsregelingAanvragen(_response);
      });
  }

  protected processBetalingsregelingAanvragen(response: AxiosResponse): Promise<KlantContactResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 404) {
      const _responseText = response.data;
      let result404: any = null;
      let resultData404 = _responseText;
      result404 = ProblemDetails.fromJS(resultData404);
      return throwException("Not Found", status, _responseText, _headers, result404);
    } else if (status === 500) {
      const _responseText = response.data;
      let result500: any = null;
      let resultData500 = _responseText;
      result500 = ProblemDetails.fromJS(resultData500);
      return throwException("Server Error", status, _responseText, _headers, result500);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = ValidationProblemDetails.fromJS(resultData400);
      return throwException("Bad Request", status, _responseText, _headers, result400);
    } else if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = KlantContactResponse.fromJS(resultData200);
      return Promise.resolve<KlantContactResponse>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<KlantContactResponse>(null as any);
  }
}

export interface IBewindvoerdersEnCuratorenClientAanmeldenEndpointClient {
  /**
   * @param body (optional)
   * @return Success
   */
  clientAanmelden(
    body?: BewindvoerdersEnCuratorenClientAanmeldenCommand | undefined
  ): Promise<KlantContactResponse>;
}

export class BewindvoerdersEnCuratorenClientAanmeldenEndpointClient
  implements IBewindvoerdersEnCuratorenClientAanmeldenEndpointClient
{
  private instance: AxiosInstance;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(baseUrl?: string, instance?: AxiosInstance) {
    this.instance = instance ? instance : axios.create();

    this.baseUrl =
      baseUrl !== undefined && baseUrl !== null
        ? baseUrl
        : "/Service/HetCak.OpenCak.KlantOndersteuning.Service";
  }

  /**
   * @param body (optional)
   * @return Success
   */
  clientAanmelden(
    body?: BewindvoerdersEnCuratorenClientAanmeldenCommand | undefined,
    cancelToken?: CancelToken | undefined
  ): Promise<KlantContactResponse> {
    let url_ =
      this.baseUrl +
      "/eb/klantondersteuning/api/v1/klantcontact/bewindvoerders-en-curatoren/client-aanmelden";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processClientAanmelden(_response);
      });
  }

  protected processClientAanmelden(response: AxiosResponse): Promise<KlantContactResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 404) {
      const _responseText = response.data;
      let result404: any = null;
      let resultData404 = _responseText;
      result404 = ProblemDetails.fromJS(resultData404);
      return throwException("Not Found", status, _responseText, _headers, result404);
    } else if (status === 500) {
      const _responseText = response.data;
      let result500: any = null;
      let resultData500 = _responseText;
      result500 = ProblemDetails.fromJS(resultData500);
      return throwException("Server Error", status, _responseText, _headers, result500);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = ValidationProblemDetails.fromJS(resultData400);
      return throwException("Bad Request", status, _responseText, _headers, result400);
    } else if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = KlantContactResponse.fromJS(resultData200);
      return Promise.resolve<KlantContactResponse>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<KlantContactResponse>(null as any);
  }
}

export interface IBewindvoerdersEnCuratorenClientWijzigenEndpointClient {
  /**
   * @param body (optional)
   * @return Success
   */
  clientWijzigen(
    body?: BewindvoerdersEnCuratorenClientWijzigenCommand | undefined
  ): Promise<KlantContactResponse>;
}

export class BewindvoerdersEnCuratorenClientWijzigenEndpointClient
  implements IBewindvoerdersEnCuratorenClientWijzigenEndpointClient
{
  private instance: AxiosInstance;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(baseUrl?: string, instance?: AxiosInstance) {
    this.instance = instance ? instance : axios.create();

    this.baseUrl =
      baseUrl !== undefined && baseUrl !== null
        ? baseUrl
        : "/Service/HetCak.OpenCak.KlantOndersteuning.Service";
  }

  /**
   * @param body (optional)
   * @return Success
   */
  clientWijzigen(
    body?: BewindvoerdersEnCuratorenClientWijzigenCommand | undefined,
    cancelToken?: CancelToken | undefined
  ): Promise<KlantContactResponse> {
    let url_ =
      this.baseUrl + "/eb/klantondersteuning/api/v1/klantcontact/bewindvoerders-en-curatoren/client-wijzigen";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processClientWijzigen(_response);
      });
  }

  protected processClientWijzigen(response: AxiosResponse): Promise<KlantContactResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 404) {
      const _responseText = response.data;
      let result404: any = null;
      let resultData404 = _responseText;
      result404 = ProblemDetails.fromJS(resultData404);
      return throwException("Not Found", status, _responseText, _headers, result404);
    } else if (status === 500) {
      const _responseText = response.data;
      let result500: any = null;
      let resultData500 = _responseText;
      result500 = ProblemDetails.fromJS(resultData500);
      return throwException("Server Error", status, _responseText, _headers, result500);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = ValidationProblemDetails.fromJS(resultData400);
      return throwException("Bad Request", status, _responseText, _headers, result400);
    } else if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = KlantContactResponse.fromJS(resultData200);
      return Promise.resolve<KlantContactResponse>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<KlantContactResponse>(null as any);
  }
}

export interface IBewindvoerdersEnCuratorenContactAanvragenEndpointClient {
  /**
   * @param body (optional)
   * @return Success
   */
  contactAanvragen(
    body?: BewindvoerdersEnCuratorenContactAanvragenCommand | undefined
  ): Promise<KlantContactResponse>;
}

export class BewindvoerdersEnCuratorenContactAanvragenEndpointClient
  implements IBewindvoerdersEnCuratorenContactAanvragenEndpointClient
{
  private instance: AxiosInstance;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(baseUrl?: string, instance?: AxiosInstance) {
    this.instance = instance ? instance : axios.create();

    this.baseUrl =
      baseUrl !== undefined && baseUrl !== null
        ? baseUrl
        : "/Service/HetCak.OpenCak.KlantOndersteuning.Service";
  }

  /**
   * @param body (optional)
   * @return Success
   */
  contactAanvragen(
    body?: BewindvoerdersEnCuratorenContactAanvragenCommand | undefined,
    cancelToken?: CancelToken | undefined
  ): Promise<KlantContactResponse> {
    let url_ =
      this.baseUrl +
      "/eb/klantondersteuning/api/v1/klantcontact/bewindvoerders-en-curatoren/contact-aanvragen";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processContactAanvragen(_response);
      });
  }

  protected processContactAanvragen(response: AxiosResponse): Promise<KlantContactResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 404) {
      const _responseText = response.data;
      let result404: any = null;
      let resultData404 = _responseText;
      result404 = ProblemDetails.fromJS(resultData404);
      return throwException("Not Found", status, _responseText, _headers, result404);
    } else if (status === 500) {
      const _responseText = response.data;
      let result500: any = null;
      let resultData500 = _responseText;
      result500 = ProblemDetails.fromJS(resultData500);
      return throwException("Server Error", status, _responseText, _headers, result500);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = ValidationProblemDetails.fromJS(resultData400);
      return throwException("Bad Request", status, _responseText, _headers, result400);
    } else if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = KlantContactResponse.fromJS(resultData200);
      return Promise.resolve<KlantContactResponse>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<KlantContactResponse>(null as any);
  }
}

export interface IContactAanvragenEndpointClient {
  /**
   * @param body (optional)
   * @return Success
   */
  contactAanvragen2(body?: ContactAanvragenCommand | undefined): Promise<KlantContactResponse>;
}

export class ContactAanvragenEndpointClient implements IContactAanvragenEndpointClient {
  private instance: AxiosInstance;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(baseUrl?: string, instance?: AxiosInstance) {
    this.instance = instance ? instance : axios.create();

    this.baseUrl =
      baseUrl !== undefined && baseUrl !== null
        ? baseUrl
        : "/Service/HetCak.OpenCak.KlantOndersteuning.Service";
  }

  /**
   * @param body (optional)
   * @return Success
   */
  contactAanvragen2(
    body?: ContactAanvragenCommand | undefined,
    cancelToken?: CancelToken | undefined
  ): Promise<KlantContactResponse> {
    let url_ = this.baseUrl + "/eb/klantondersteuning/api/v1/klantcontact/contact-aanvragen";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processContactAanvragen2(_response);
      });
  }

  protected processContactAanvragen2(response: AxiosResponse): Promise<KlantContactResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 404) {
      const _responseText = response.data;
      let result404: any = null;
      let resultData404 = _responseText;
      result404 = ProblemDetails.fromJS(resultData404);
      return throwException("Not Found", status, _responseText, _headers, result404);
    } else if (status === 500) {
      const _responseText = response.data;
      let result500: any = null;
      let resultData500 = _responseText;
      result500 = ProblemDetails.fromJS(resultData500);
      return throwException("Server Error", status, _responseText, _headers, result500);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = ValidationProblemDetails.fromJS(resultData400);
      return throwException("Bad Request", status, _responseText, _headers, result400);
    } else if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = KlantContactResponse.fromJS(resultData200);
      return Promise.resolve<KlantContactResponse>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<KlantContactResponse>(null as any);
  }
}

export interface IKlachtIndienenEndpointClient {
  /**
   * @param body (optional)
   * @return Success
   */
  klachtIndienen(body?: KlachtIndienenCommand | undefined): Promise<KlantContactResponse>;
}

export class KlachtIndienenEndpointClient implements IKlachtIndienenEndpointClient {
  private instance: AxiosInstance;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(baseUrl?: string, instance?: AxiosInstance) {
    this.instance = instance ? instance : axios.create();

    this.baseUrl =
      baseUrl !== undefined && baseUrl !== null
        ? baseUrl
        : "/Service/HetCak.OpenCak.KlantOndersteuning.Service";
  }

  /**
   * @param body (optional)
   * @return Success
   */
  klachtIndienen(
    body?: KlachtIndienenCommand | undefined,
    cancelToken?: CancelToken | undefined
  ): Promise<KlantContactResponse> {
    let url_ = this.baseUrl + "/eb/klantondersteuning/api/v1/klantcontact/klacht-indienen";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processKlachtIndienen(_response);
      });
  }

  protected processKlachtIndienen(response: AxiosResponse): Promise<KlantContactResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 404) {
      const _responseText = response.data;
      let result404: any = null;
      let resultData404 = _responseText;
      result404 = ProblemDetails.fromJS(resultData404);
      return throwException("Not Found", status, _responseText, _headers, result404);
    } else if (status === 500) {
      const _responseText = response.data;
      let result500: any = null;
      let resultData500 = _responseText;
      result500 = ProblemDetails.fromJS(resultData500);
      return throwException("Server Error", status, _responseText, _headers, result500);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = ValidationProblemDetails.fromJS(resultData400);
      return throwException("Bad Request", status, _responseText, _headers, result400);
    } else if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = KlantContactResponse.fromJS(resultData200);
      return Promise.resolve<KlantContactResponse>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<KlantContactResponse>(null as any);
  }
}

export class Adres implements IAdres {
  straatnaam!: string;
  huisnummer!: string;
  toevoeging?: string | null;
  postcode!: string;
  plaatsnaam!: string;

  constructor(data?: IAdres) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.straatnaam = _data["straatnaam"] !== undefined ? _data["straatnaam"] : <any>null;
      this.huisnummer = _data["huisnummer"] !== undefined ? _data["huisnummer"] : <any>null;
      this.toevoeging = _data["toevoeging"] !== undefined ? _data["toevoeging"] : <any>null;
      this.postcode = _data["postcode"] !== undefined ? _data["postcode"] : <any>null;
      this.plaatsnaam = _data["plaatsnaam"] !== undefined ? _data["plaatsnaam"] : <any>null;
    }
  }

  static fromJS(data: any): Adres {
    data = typeof data === "object" ? data : {};
    let result = new Adres();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["straatnaam"] = this.straatnaam !== undefined ? this.straatnaam : <any>null;
    data["huisnummer"] = this.huisnummer !== undefined ? this.huisnummer : <any>null;
    data["toevoeging"] = this.toevoeging !== undefined ? this.toevoeging : <any>null;
    data["postcode"] = this.postcode !== undefined ? this.postcode : <any>null;
    data["plaatsnaam"] = this.plaatsnaam !== undefined ? this.plaatsnaam : <any>null;
    return data;
  }
}

export interface IAdres {
  straatnaam: string;
  huisnummer: string;
  toevoeging?: string | null;
  postcode: string;
  plaatsnaam: string;
}

export class BetalingsregelingAanvragenCommand implements IBetalingsregelingAanvragenCommand {
  maxBedragPerMaand!: number;
  toelichting?: string | null;
  voorletters!: string;
  achternaam!: string;
  emailAdres!: string;
  telefoonnummer!: string;
  klantnummer!: string;
  geboortedatum!: Date;
  emailBevestigingOntvangen?: boolean;

  constructor(data?: IBetalingsregelingAanvragenCommand) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.maxBedragPerMaand =
        _data["maxBedragPerMaand"] !== undefined ? _data["maxBedragPerMaand"] : <any>null;
      this.toelichting = _data["toelichting"] !== undefined ? _data["toelichting"] : <any>null;
      this.voorletters = _data["voorletters"] !== undefined ? _data["voorletters"] : <any>null;
      this.achternaam = _data["achternaam"] !== undefined ? _data["achternaam"] : <any>null;
      this.emailAdres = _data["emailAdres"] !== undefined ? _data["emailAdres"] : <any>null;
      this.telefoonnummer = _data["telefoonnummer"] !== undefined ? _data["telefoonnummer"] : <any>null;
      this.klantnummer = _data["klantnummer"] !== undefined ? _data["klantnummer"] : <any>null;
      this.geboortedatum = _data["geboortedatum"] ? new Date(_data["geboortedatum"].toString()) : <any>null;
      this.emailBevestigingOntvangen =
        _data["emailBevestigingOntvangen"] !== undefined ? _data["emailBevestigingOntvangen"] : <any>null;
    }
  }

  static fromJS(data: any): BetalingsregelingAanvragenCommand {
    data = typeof data === "object" ? data : {};
    let result = new BetalingsregelingAanvragenCommand();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["maxBedragPerMaand"] = this.maxBedragPerMaand !== undefined ? this.maxBedragPerMaand : <any>null;
    data["toelichting"] = this.toelichting !== undefined ? this.toelichting : <any>null;
    data["voorletters"] = this.voorletters !== undefined ? this.voorletters : <any>null;
    data["achternaam"] = this.achternaam !== undefined ? this.achternaam : <any>null;
    data["emailAdres"] = this.emailAdres !== undefined ? this.emailAdres : <any>null;
    data["telefoonnummer"] = this.telefoonnummer !== undefined ? this.telefoonnummer : <any>null;
    data["klantnummer"] = this.klantnummer !== undefined ? this.klantnummer : <any>null;
    data["geboortedatum"] = this.geboortedatum ? this.geboortedatum.toISOString() : <any>null;
    data["emailBevestigingOntvangen"] =
      this.emailBevestigingOntvangen !== undefined ? this.emailBevestigingOntvangen : <any>null;
    return data;
  }
}

export interface IBetalingsregelingAanvragenCommand {
  maxBedragPerMaand: number;
  toelichting?: string | null;
  voorletters: string;
  achternaam: string;
  emailAdres: string;
  telefoonnummer: string;
  klantnummer: string;
  geboortedatum: Date;
  emailBevestigingOntvangen?: boolean;
}

export class BewindvoerdersEnCuratorenClientAanmeldenCommand
  implements IBewindvoerdersEnCuratorenClientAanmeldenCommand
{
  regeling?: Regeling;
  rol!: string;
  naamKantoor?: string | null;
  aanhef!: string;
  voorletters!: string;
  achternaam!: string;
  adres!: Adres;
  emailAdres!: string;
  telefoonnummer!: string;
  client!: Client;
  iban!: string;
  clientStaatInRegister?: boolean;
  bijlagen?: Bijlage[] | null;
  andereVragenOfOpmerkingen?: string | null;
  emailBevestigingOntvangen?: boolean;

  constructor(data?: IBewindvoerdersEnCuratorenClientAanmeldenCommand) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
      this.adres = data.adres && !(<any>data.adres).toJSON ? new Adres(data.adres) : <Adres>this.adres;
      this.client = data.client && !(<any>data.client).toJSON ? new Client(data.client) : <Client>this.client;
      if (data.bijlagen) {
        this.bijlagen = [];
        for (let i = 0; i < data.bijlagen.length; i++) {
          let item = data.bijlagen[i];
          this.bijlagen[i] = item && !(<any>item).toJSON ? new Bijlage(item) : <Bijlage>item;
        }
      }
    }
    if (!data) {
      this.adres = new Adres();
      this.client = new Client();
    }
  }

  init(_data?: any) {
    if (_data) {
      this.regeling = _data["regeling"] !== undefined ? _data["regeling"] : <any>null;
      this.rol = _data["rol"] !== undefined ? _data["rol"] : <any>null;
      this.naamKantoor = _data["naamKantoor"] !== undefined ? _data["naamKantoor"] : <any>null;
      this.aanhef = _data["aanhef"] !== undefined ? _data["aanhef"] : <any>null;
      this.voorletters = _data["voorletters"] !== undefined ? _data["voorletters"] : <any>null;
      this.achternaam = _data["achternaam"] !== undefined ? _data["achternaam"] : <any>null;
      this.adres = _data["adres"] ? Adres.fromJS(_data["adres"]) : new Adres();
      this.emailAdres = _data["emailAdres"] !== undefined ? _data["emailAdres"] : <any>null;
      this.telefoonnummer = _data["telefoonnummer"] !== undefined ? _data["telefoonnummer"] : <any>null;
      this.client = _data["client"] ? Client.fromJS(_data["client"]) : new Client();
      this.iban = _data["iban"] !== undefined ? _data["iban"] : <any>null;
      this.clientStaatInRegister =
        _data["clientStaatInRegister"] !== undefined ? _data["clientStaatInRegister"] : <any>null;
      if (Array.isArray(_data["bijlagen"])) {
        this.bijlagen = [] as any;
        for (let item of _data["bijlagen"]) this.bijlagen!.push(Bijlage.fromJS(item));
      } else {
        this.bijlagen = <any>null;
      }
      this.andereVragenOfOpmerkingen =
        _data["andereVragenOfOpmerkingen"] !== undefined ? _data["andereVragenOfOpmerkingen"] : <any>null;
      this.emailBevestigingOntvangen =
        _data["emailBevestigingOntvangen"] !== undefined ? _data["emailBevestigingOntvangen"] : <any>null;
    }
  }

  static fromJS(data: any): BewindvoerdersEnCuratorenClientAanmeldenCommand {
    data = typeof data === "object" ? data : {};
    let result = new BewindvoerdersEnCuratorenClientAanmeldenCommand();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["regeling"] = this.regeling !== undefined ? this.regeling : <any>null;
    data["rol"] = this.rol !== undefined ? this.rol : <any>null;
    data["naamKantoor"] = this.naamKantoor !== undefined ? this.naamKantoor : <any>null;
    data["aanhef"] = this.aanhef !== undefined ? this.aanhef : <any>null;
    data["voorletters"] = this.voorletters !== undefined ? this.voorletters : <any>null;
    data["achternaam"] = this.achternaam !== undefined ? this.achternaam : <any>null;
    data["adres"] = this.adres ? this.adres.toJSON() : <any>null;
    data["emailAdres"] = this.emailAdres !== undefined ? this.emailAdres : <any>null;
    data["telefoonnummer"] = this.telefoonnummer !== undefined ? this.telefoonnummer : <any>null;
    data["client"] = this.client ? this.client.toJSON() : <any>null;
    data["iban"] = this.iban !== undefined ? this.iban : <any>null;
    data["clientStaatInRegister"] =
      this.clientStaatInRegister !== undefined ? this.clientStaatInRegister : <any>null;
    if (Array.isArray(this.bijlagen)) {
      data["bijlagen"] = [];
      for (let item of this.bijlagen) data["bijlagen"].push(item.toJSON());
    }
    data["andereVragenOfOpmerkingen"] =
      this.andereVragenOfOpmerkingen !== undefined ? this.andereVragenOfOpmerkingen : <any>null;
    data["emailBevestigingOntvangen"] =
      this.emailBevestigingOntvangen !== undefined ? this.emailBevestigingOntvangen : <any>null;
    return data;
  }
}

export interface IBewindvoerdersEnCuratorenClientAanmeldenCommand {
  regeling?: Regeling;
  rol: string;
  naamKantoor?: string | null;
  aanhef: string;
  voorletters: string;
  achternaam: string;
  adres: IAdres;
  emailAdres: string;
  telefoonnummer: string;
  client: IClient;
  iban: string;
  clientStaatInRegister?: boolean;
  bijlagen?: IBijlage[] | null;
  andereVragenOfOpmerkingen?: string | null;
  emailBevestigingOntvangen?: boolean;
}

export class BewindvoerdersEnCuratorenClientWijzigenCommand
  implements IBewindvoerdersEnCuratorenClientWijzigenCommand
{
  regeling?: Regeling;
  wsnpBewindvoerderOfCuratorBijFaillissement?: boolean;
  aanhef!: string;
  achternaam!: string;
  emailAdres!: string;
  emailBevestigingOntvangen?: boolean;
  telefoonnummer!: string;
  client!: Client;
  rekeningnummerVanClientDoorgeven?: boolean;
  ibanClient?: string | null;
  automatischeIncassoStopzetten?: boolean;
  ibanAutomatischeIncasso?: string | null;
  kopieVanBeschikkingOntvangen?: boolean;
  beschikkingsJaar?: string | null;
  overzichtVanOpenstaandeFacturenOntvangen?: boolean;
  betalingsregelingAanvragen?: boolean;
  aantalTermijnenBetalingsregeling?: number | null;
  andereVragenOfOpmerkingen?: string | null;
  bijlagen?: Bijlage[] | null;

  constructor(data?: IBewindvoerdersEnCuratorenClientWijzigenCommand) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
      this.client = data.client && !(<any>data.client).toJSON ? new Client(data.client) : <Client>this.client;
      if (data.bijlagen) {
        this.bijlagen = [];
        for (let i = 0; i < data.bijlagen.length; i++) {
          let item = data.bijlagen[i];
          this.bijlagen[i] = item && !(<any>item).toJSON ? new Bijlage(item) : <Bijlage>item;
        }
      }
    }
    if (!data) {
      this.client = new Client();
    }
  }

  init(_data?: any) {
    if (_data) {
      this.regeling = _data["regeling"] !== undefined ? _data["regeling"] : <any>null;
      this.wsnpBewindvoerderOfCuratorBijFaillissement =
        _data["wsnpBewindvoerderOfCuratorBijFaillissement"] !== undefined
          ? _data["wsnpBewindvoerderOfCuratorBijFaillissement"]
          : <any>null;
      this.aanhef = _data["aanhef"] !== undefined ? _data["aanhef"] : <any>null;
      this.achternaam = _data["achternaam"] !== undefined ? _data["achternaam"] : <any>null;
      this.emailAdres = _data["emailAdres"] !== undefined ? _data["emailAdres"] : <any>null;
      this.emailBevestigingOntvangen =
        _data["emailBevestigingOntvangen"] !== undefined ? _data["emailBevestigingOntvangen"] : <any>null;
      this.telefoonnummer = _data["telefoonnummer"] !== undefined ? _data["telefoonnummer"] : <any>null;
      this.client = _data["client"] ? Client.fromJS(_data["client"]) : new Client();
      this.rekeningnummerVanClientDoorgeven =
        _data["rekeningnummerVanClientDoorgeven"] !== undefined
          ? _data["rekeningnummerVanClientDoorgeven"]
          : <any>null;
      this.ibanClient = _data["ibanClient"] !== undefined ? _data["ibanClient"] : <any>null;
      this.automatischeIncassoStopzetten =
        _data["automatischeIncassoStopzetten"] !== undefined
          ? _data["automatischeIncassoStopzetten"]
          : <any>null;
      this.ibanAutomatischeIncasso =
        _data["ibanAutomatischeIncasso"] !== undefined ? _data["ibanAutomatischeIncasso"] : <any>null;
      this.kopieVanBeschikkingOntvangen =
        _data["kopieVanBeschikkingOntvangen"] !== undefined
          ? _data["kopieVanBeschikkingOntvangen"]
          : <any>null;
      this.beschikkingsJaar = _data["beschikkingsJaar"] !== undefined ? _data["beschikkingsJaar"] : <any>null;
      this.overzichtVanOpenstaandeFacturenOntvangen =
        _data["overzichtVanOpenstaandeFacturenOntvangen"] !== undefined
          ? _data["overzichtVanOpenstaandeFacturenOntvangen"]
          : <any>null;
      this.betalingsregelingAanvragen =
        _data["betalingsregelingAanvragen"] !== undefined ? _data["betalingsregelingAanvragen"] : <any>null;
      this.aantalTermijnenBetalingsregeling =
        _data["aantalTermijnenBetalingsregeling"] !== undefined
          ? _data["aantalTermijnenBetalingsregeling"]
          : <any>null;
      this.andereVragenOfOpmerkingen =
        _data["andereVragenOfOpmerkingen"] !== undefined ? _data["andereVragenOfOpmerkingen"] : <any>null;
      if (Array.isArray(_data["bijlagen"])) {
        this.bijlagen = [] as any;
        for (let item of _data["bijlagen"]) this.bijlagen!.push(Bijlage.fromJS(item));
      } else {
        this.bijlagen = <any>null;
      }
    }
  }

  static fromJS(data: any): BewindvoerdersEnCuratorenClientWijzigenCommand {
    data = typeof data === "object" ? data : {};
    let result = new BewindvoerdersEnCuratorenClientWijzigenCommand();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["regeling"] = this.regeling !== undefined ? this.regeling : <any>null;
    data["wsnpBewindvoerderOfCuratorBijFaillissement"] =
      this.wsnpBewindvoerderOfCuratorBijFaillissement !== undefined
        ? this.wsnpBewindvoerderOfCuratorBijFaillissement
        : <any>null;
    data["aanhef"] = this.aanhef !== undefined ? this.aanhef : <any>null;
    data["achternaam"] = this.achternaam !== undefined ? this.achternaam : <any>null;
    data["emailAdres"] = this.emailAdres !== undefined ? this.emailAdres : <any>null;
    data["emailBevestigingOntvangen"] =
      this.emailBevestigingOntvangen !== undefined ? this.emailBevestigingOntvangen : <any>null;
    data["telefoonnummer"] = this.telefoonnummer !== undefined ? this.telefoonnummer : <any>null;
    data["client"] = this.client ? this.client.toJSON() : <any>null;
    data["rekeningnummerVanClientDoorgeven"] =
      this.rekeningnummerVanClientDoorgeven !== undefined ? this.rekeningnummerVanClientDoorgeven : <any>null;
    data["ibanClient"] = this.ibanClient !== undefined ? this.ibanClient : <any>null;
    data["automatischeIncassoStopzetten"] =
      this.automatischeIncassoStopzetten !== undefined ? this.automatischeIncassoStopzetten : <any>null;
    data["ibanAutomatischeIncasso"] =
      this.ibanAutomatischeIncasso !== undefined ? this.ibanAutomatischeIncasso : <any>null;
    data["kopieVanBeschikkingOntvangen"] =
      this.kopieVanBeschikkingOntvangen !== undefined ? this.kopieVanBeschikkingOntvangen : <any>null;
    data["beschikkingsJaar"] = this.beschikkingsJaar !== undefined ? this.beschikkingsJaar : <any>null;
    data["overzichtVanOpenstaandeFacturenOntvangen"] =
      this.overzichtVanOpenstaandeFacturenOntvangen !== undefined
        ? this.overzichtVanOpenstaandeFacturenOntvangen
        : <any>null;
    data["betalingsregelingAanvragen"] =
      this.betalingsregelingAanvragen !== undefined ? this.betalingsregelingAanvragen : <any>null;
    data["aantalTermijnenBetalingsregeling"] =
      this.aantalTermijnenBetalingsregeling !== undefined ? this.aantalTermijnenBetalingsregeling : <any>null;
    data["andereVragenOfOpmerkingen"] =
      this.andereVragenOfOpmerkingen !== undefined ? this.andereVragenOfOpmerkingen : <any>null;
    if (Array.isArray(this.bijlagen)) {
      data["bijlagen"] = [];
      for (let item of this.bijlagen) data["bijlagen"].push(item.toJSON());
    }
    return data;
  }
}

export interface IBewindvoerdersEnCuratorenClientWijzigenCommand {
  regeling?: Regeling;
  wsnpBewindvoerderOfCuratorBijFaillissement?: boolean;
  aanhef: string;
  achternaam: string;
  emailAdres: string;
  emailBevestigingOntvangen?: boolean;
  telefoonnummer: string;
  client: IClient;
  rekeningnummerVanClientDoorgeven?: boolean;
  ibanClient?: string | null;
  automatischeIncassoStopzetten?: boolean;
  ibanAutomatischeIncasso?: string | null;
  kopieVanBeschikkingOntvangen?: boolean;
  beschikkingsJaar?: string | null;
  overzichtVanOpenstaandeFacturenOntvangen?: boolean;
  betalingsregelingAanvragen?: boolean;
  aantalTermijnenBetalingsregeling?: number | null;
  andereVragenOfOpmerkingen?: string | null;
  bijlagen?: IBijlage[] | null;
}

export class BewindvoerdersEnCuratorenContactAanvragenCommand
  implements IBewindvoerdersEnCuratorenContactAanvragenCommand
{
  regeling?: Regeling;
  bericht!: string;
  naamKantoor?: string | null;
  aanhef!: string;
  voorletters!: string;
  achternaam!: string;
  emailAdres!: string;
  emailBevestigingOntvangen?: boolean;
  telefoonnummer!: string;
  naamClient!: string;
  kenmerkCak!: string;
  geboortedatumClient!: Date;
  bijlagen?: Bijlage[] | null;

  constructor(data?: IBewindvoerdersEnCuratorenContactAanvragenCommand) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
      if (data.bijlagen) {
        this.bijlagen = [];
        for (let i = 0; i < data.bijlagen.length; i++) {
          let item = data.bijlagen[i];
          this.bijlagen[i] = item && !(<any>item).toJSON ? new Bijlage(item) : <Bijlage>item;
        }
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.regeling = _data["regeling"] !== undefined ? _data["regeling"] : <any>null;
      this.bericht = _data["bericht"] !== undefined ? _data["bericht"] : <any>null;
      this.naamKantoor = _data["naamKantoor"] !== undefined ? _data["naamKantoor"] : <any>null;
      this.aanhef = _data["aanhef"] !== undefined ? _data["aanhef"] : <any>null;
      this.voorletters = _data["voorletters"] !== undefined ? _data["voorletters"] : <any>null;
      this.achternaam = _data["achternaam"] !== undefined ? _data["achternaam"] : <any>null;
      this.emailAdres = _data["emailAdres"] !== undefined ? _data["emailAdres"] : <any>null;
      this.emailBevestigingOntvangen =
        _data["emailBevestigingOntvangen"] !== undefined ? _data["emailBevestigingOntvangen"] : <any>null;
      this.telefoonnummer = _data["telefoonnummer"] !== undefined ? _data["telefoonnummer"] : <any>null;
      this.naamClient = _data["naamClient"] !== undefined ? _data["naamClient"] : <any>null;
      this.kenmerkCak = _data["kenmerkCak"] !== undefined ? _data["kenmerkCak"] : <any>null;
      this.geboortedatumClient = _data["geboortedatumClient"]
        ? new Date(_data["geboortedatumClient"].toString())
        : <any>null;
      if (Array.isArray(_data["bijlagen"])) {
        this.bijlagen = [] as any;
        for (let item of _data["bijlagen"]) this.bijlagen!.push(Bijlage.fromJS(item));
      } else {
        this.bijlagen = <any>null;
      }
    }
  }

  static fromJS(data: any): BewindvoerdersEnCuratorenContactAanvragenCommand {
    data = typeof data === "object" ? data : {};
    let result = new BewindvoerdersEnCuratorenContactAanvragenCommand();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["regeling"] = this.regeling !== undefined ? this.regeling : <any>null;
    data["bericht"] = this.bericht !== undefined ? this.bericht : <any>null;
    data["naamKantoor"] = this.naamKantoor !== undefined ? this.naamKantoor : <any>null;
    data["aanhef"] = this.aanhef !== undefined ? this.aanhef : <any>null;
    data["voorletters"] = this.voorletters !== undefined ? this.voorletters : <any>null;
    data["achternaam"] = this.achternaam !== undefined ? this.achternaam : <any>null;
    data["emailAdres"] = this.emailAdres !== undefined ? this.emailAdres : <any>null;
    data["emailBevestigingOntvangen"] =
      this.emailBevestigingOntvangen !== undefined ? this.emailBevestigingOntvangen : <any>null;
    data["telefoonnummer"] = this.telefoonnummer !== undefined ? this.telefoonnummer : <any>null;
    data["naamClient"] = this.naamClient !== undefined ? this.naamClient : <any>null;
    data["kenmerkCak"] = this.kenmerkCak !== undefined ? this.kenmerkCak : <any>null;
    data["geboortedatumClient"] = this.geboortedatumClient
      ? this.geboortedatumClient.toISOString()
      : <any>null;
    if (Array.isArray(this.bijlagen)) {
      data["bijlagen"] = [];
      for (let item of this.bijlagen) data["bijlagen"].push(item.toJSON());
    }
    return data;
  }
}

export interface IBewindvoerdersEnCuratorenContactAanvragenCommand {
  regeling?: Regeling;
  bericht: string;
  naamKantoor?: string | null;
  aanhef: string;
  voorletters: string;
  achternaam: string;
  emailAdres: string;
  emailBevestigingOntvangen?: boolean;
  telefoonnummer: string;
  naamClient: string;
  kenmerkCak: string;
  geboortedatumClient: Date;
  bijlagen?: IBijlage[] | null;
}

export class Bijlage implements IBijlage {
  bestandsnaam!: string;
  base64Inhoud?: string | null;

  constructor(data?: IBijlage) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.bestandsnaam = _data["bestandsnaam"] !== undefined ? _data["bestandsnaam"] : <any>null;
      this.base64Inhoud = _data["base64Inhoud"] !== undefined ? _data["base64Inhoud"] : <any>null;
    }
  }

  static fromJS(data: any): Bijlage {
    data = typeof data === "object" ? data : {};
    let result = new Bijlage();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["bestandsnaam"] = this.bestandsnaam !== undefined ? this.bestandsnaam : <any>null;
    data["base64Inhoud"] = this.base64Inhoud !== undefined ? this.base64Inhoud : <any>null;
    return data;
  }
}

export interface IBijlage {
  bestandsnaam: string;
  base64Inhoud?: string | null;
}

export class Client implements IClient {
  naam!: string;
  burgerservicenummer!: string;
  geboortedatum!: Date;

  constructor(data?: IClient) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.naam = _data["naam"] !== undefined ? _data["naam"] : <any>null;
      this.burgerservicenummer =
        _data["burgerservicenummer"] !== undefined ? _data["burgerservicenummer"] : <any>null;
      this.geboortedatum = _data["geboortedatum"] ? new Date(_data["geboortedatum"].toString()) : <any>null;
    }
  }

  static fromJS(data: any): Client {
    data = typeof data === "object" ? data : {};
    let result = new Client();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["naam"] = this.naam !== undefined ? this.naam : <any>null;
    data["burgerservicenummer"] =
      this.burgerservicenummer !== undefined ? this.burgerservicenummer : <any>null;
    data["geboortedatum"] = this.geboortedatum ? this.geboortedatum.toISOString() : <any>null;
    return data;
  }
}

export interface IClient {
  naam: string;
  burgerservicenummer: string;
  geboortedatum: Date;
}

export class ContactAanvragenCommand implements IContactAanvragenCommand {
  regeling?: Regeling;
  actie?: string | null;
  bericht!: string;
  voorletters?: string | null;
  achternaam!: string;
  emailAdres!: string;
  telefoonnummer?: string | null;
  burgerservicenummer?: string | null;
  kenmerkCak?: string | null;
  geboortedatum?: Date | null;
  emailBevestigingOntvangen?: boolean;
  bijlagen?: Bijlage[] | null;

  constructor(data?: IContactAanvragenCommand) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
      if (data.bijlagen) {
        this.bijlagen = [];
        for (let i = 0; i < data.bijlagen.length; i++) {
          let item = data.bijlagen[i];
          this.bijlagen[i] = item && !(<any>item).toJSON ? new Bijlage(item) : <Bijlage>item;
        }
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.regeling = _data["regeling"] !== undefined ? _data["regeling"] : <any>null;
      this.actie = _data["actie"] !== undefined ? _data["actie"] : <any>null;
      this.bericht = _data["bericht"] !== undefined ? _data["bericht"] : <any>null;
      this.voorletters = _data["voorletters"] !== undefined ? _data["voorletters"] : <any>null;
      this.achternaam = _data["achternaam"] !== undefined ? _data["achternaam"] : <any>null;
      this.emailAdres = _data["emailAdres"] !== undefined ? _data["emailAdres"] : <any>null;
      this.telefoonnummer = _data["telefoonnummer"] !== undefined ? _data["telefoonnummer"] : <any>null;
      this.burgerservicenummer =
        _data["burgerservicenummer"] !== undefined ? _data["burgerservicenummer"] : <any>null;
      this.kenmerkCak = _data["kenmerkCak"] !== undefined ? _data["kenmerkCak"] : <any>null;
      this.geboortedatum = _data["geboortedatum"] ? new Date(_data["geboortedatum"].toString()) : <any>null;
      this.emailBevestigingOntvangen =
        _data["emailBevestigingOntvangen"] !== undefined ? _data["emailBevestigingOntvangen"] : <any>null;
      if (Array.isArray(_data["bijlagen"])) {
        this.bijlagen = [] as any;
        for (let item of _data["bijlagen"]) this.bijlagen!.push(Bijlage.fromJS(item));
      } else {
        this.bijlagen = <any>null;
      }
    }
  }

  static fromJS(data: any): ContactAanvragenCommand {
    data = typeof data === "object" ? data : {};
    let result = new ContactAanvragenCommand();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["regeling"] = this.regeling !== undefined ? this.regeling : <any>null;
    data["actie"] = this.actie !== undefined ? this.actie : <any>null;
    data["bericht"] = this.bericht !== undefined ? this.bericht : <any>null;
    data["voorletters"] = this.voorletters !== undefined ? this.voorletters : <any>null;
    data["achternaam"] = this.achternaam !== undefined ? this.achternaam : <any>null;
    data["emailAdres"] = this.emailAdres !== undefined ? this.emailAdres : <any>null;
    data["telefoonnummer"] = this.telefoonnummer !== undefined ? this.telefoonnummer : <any>null;
    data["burgerservicenummer"] =
      this.burgerservicenummer !== undefined ? this.burgerservicenummer : <any>null;
    data["kenmerkCak"] = this.kenmerkCak !== undefined ? this.kenmerkCak : <any>null;
    data["geboortedatum"] = this.geboortedatum ? this.geboortedatum.toISOString() : <any>null;
    data["emailBevestigingOntvangen"] =
      this.emailBevestigingOntvangen !== undefined ? this.emailBevestigingOntvangen : <any>null;
    if (Array.isArray(this.bijlagen)) {
      data["bijlagen"] = [];
      for (let item of this.bijlagen) data["bijlagen"].push(item.toJSON());
    }
    return data;
  }
}

export interface IContactAanvragenCommand {
  regeling?: Regeling;
  actie?: string | null;
  bericht: string;
  voorletters?: string | null;
  achternaam: string;
  emailAdres: string;
  telefoonnummer?: string | null;
  burgerservicenummer?: string | null;
  kenmerkCak?: string | null;
  geboortedatum?: Date | null;
  emailBevestigingOntvangen?: boolean;
  bijlagen?: IBijlage[] | null;
}

export class KlachtIndienenCommand implements IKlachtIndienenCommand {
  regeling?: Regeling;
  bericht!: string;
  voorletters?: string | null;
  achternaam!: string;
  emailAdres!: string;
  telefoonnummer?: string | null;
  burgerservicenummer?: string | null;
  geboortedatum?: Date | null;
  emailBevestigingOntvangen?: boolean;
  bijlagen?: Bijlage[] | null;

  constructor(data?: IKlachtIndienenCommand) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
      if (data.bijlagen) {
        this.bijlagen = [];
        for (let i = 0; i < data.bijlagen.length; i++) {
          let item = data.bijlagen[i];
          this.bijlagen[i] = item && !(<any>item).toJSON ? new Bijlage(item) : <Bijlage>item;
        }
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.regeling = _data["regeling"] !== undefined ? _data["regeling"] : <any>null;
      this.bericht = _data["bericht"] !== undefined ? _data["bericht"] : <any>null;
      this.voorletters = _data["voorletters"] !== undefined ? _data["voorletters"] : <any>null;
      this.achternaam = _data["achternaam"] !== undefined ? _data["achternaam"] : <any>null;
      this.emailAdres = _data["emailAdres"] !== undefined ? _data["emailAdres"] : <any>null;
      this.telefoonnummer = _data["telefoonnummer"] !== undefined ? _data["telefoonnummer"] : <any>null;
      this.burgerservicenummer =
        _data["burgerservicenummer"] !== undefined ? _data["burgerservicenummer"] : <any>null;
      this.geboortedatum = _data["geboortedatum"] ? new Date(_data["geboortedatum"].toString()) : <any>null;
      this.emailBevestigingOntvangen =
        _data["emailBevestigingOntvangen"] !== undefined ? _data["emailBevestigingOntvangen"] : <any>null;
      if (Array.isArray(_data["bijlagen"])) {
        this.bijlagen = [] as any;
        for (let item of _data["bijlagen"]) this.bijlagen!.push(Bijlage.fromJS(item));
      } else {
        this.bijlagen = <any>null;
      }
    }
  }

  static fromJS(data: any): KlachtIndienenCommand {
    data = typeof data === "object" ? data : {};
    let result = new KlachtIndienenCommand();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["regeling"] = this.regeling !== undefined ? this.regeling : <any>null;
    data["bericht"] = this.bericht !== undefined ? this.bericht : <any>null;
    data["voorletters"] = this.voorletters !== undefined ? this.voorletters : <any>null;
    data["achternaam"] = this.achternaam !== undefined ? this.achternaam : <any>null;
    data["emailAdres"] = this.emailAdres !== undefined ? this.emailAdres : <any>null;
    data["telefoonnummer"] = this.telefoonnummer !== undefined ? this.telefoonnummer : <any>null;
    data["burgerservicenummer"] =
      this.burgerservicenummer !== undefined ? this.burgerservicenummer : <any>null;
    data["geboortedatum"] = this.geboortedatum ? this.geboortedatum.toISOString() : <any>null;
    data["emailBevestigingOntvangen"] =
      this.emailBevestigingOntvangen !== undefined ? this.emailBevestigingOntvangen : <any>null;
    if (Array.isArray(this.bijlagen)) {
      data["bijlagen"] = [];
      for (let item of this.bijlagen) data["bijlagen"].push(item.toJSON());
    }
    return data;
  }
}

export interface IKlachtIndienenCommand {
  regeling?: Regeling;
  bericht: string;
  voorletters?: string | null;
  achternaam: string;
  emailAdres: string;
  telefoonnummer?: string | null;
  burgerservicenummer?: string | null;
  geboortedatum?: Date | null;
  emailBevestigingOntvangen?: boolean;
  bijlagen?: IBijlage[] | null;
}

export class KlantContactResponse implements IKlantContactResponse {
  klantContactId?: number;
  bericht?: string | null;

  constructor(data?: IKlantContactResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.klantContactId = _data["klantContactId"] !== undefined ? _data["klantContactId"] : <any>null;
      this.bericht = _data["bericht"] !== undefined ? _data["bericht"] : <any>null;
    }
  }

  static fromJS(data: any): KlantContactResponse {
    data = typeof data === "object" ? data : {};
    let result = new KlantContactResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["klantContactId"] = this.klantContactId !== undefined ? this.klantContactId : <any>null;
    data["bericht"] = this.bericht !== undefined ? this.bericht : <any>null;
    return data;
  }
}

export interface IKlantContactResponse {
  klantContactId?: number;
  bericht?: string | null;
}

export class ProblemDetails implements IProblemDetails {
  type?: string | null;
  title?: string | null;
  status?: number | null;
  detail?: string | null;
  instance?: string | null;

  [key: string]: any;

  constructor(data?: IProblemDetails) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      for (var property in _data) {
        if (_data.hasOwnProperty(property)) this[property] = _data[property];
      }
      this.type = _data["type"] !== undefined ? _data["type"] : <any>null;
      this.title = _data["title"] !== undefined ? _data["title"] : <any>null;
      this.status = _data["status"] !== undefined ? _data["status"] : <any>null;
      this.detail = _data["detail"] !== undefined ? _data["detail"] : <any>null;
      this.instance = _data["instance"] !== undefined ? _data["instance"] : <any>null;
    }
  }

  static fromJS(data: any): ProblemDetails {
    data = typeof data === "object" ? data : {};
    let result = new ProblemDetails();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    for (var property in this) {
      if (this.hasOwnProperty(property)) data[property] = this[property];
    }
    data["type"] = this.type !== undefined ? this.type : <any>null;
    data["title"] = this.title !== undefined ? this.title : <any>null;
    data["status"] = this.status !== undefined ? this.status : <any>null;
    data["detail"] = this.detail !== undefined ? this.detail : <any>null;
    data["instance"] = this.instance !== undefined ? this.instance : <any>null;
    return data;
  }
}

export interface IProblemDetails {
  type?: string | null;
  title?: string | null;
  status?: number | null;
  detail?: string | null;
  instance?: string | null;

  [key: string]: any;
}

export enum Regeling {
  BeschermdWonen = "BeschermdWonen",
  Buitenland = "Buitenland",
  CBHC = "CBHC",
  Gemoedsbezwaarden = "Gemoedsbezwaarden",
  MedicijnenMeeOpReis = "MedicijnenMeeOpReis",
  OnverzekerbareVreemdelingen = "OnverzekerbareVreemdelingen",
  Onverzekerden = "Onverzekerden",
  SOV = "SOV",
  Wanbetalers = "Wanbetalers",
  Wlz = "Wlz",
  WmoAT = "WmoAT",
  Onbekend = "Onbekend"
}

export class ValidationProblemDetails implements IValidationProblemDetails {
  type?: string | null;
  title?: string | null;
  status?: number | null;
  detail?: string | null;
  instance?: string | null;
  readonly errors?: { [key: string]: string[] } | null;

  [key: string]: any;

  constructor(data?: IValidationProblemDetails) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      for (var property in _data) {
        if (_data.hasOwnProperty(property)) this[property] = _data[property];
      }
      this.type = _data["type"] !== undefined ? _data["type"] : <any>null;
      this.title = _data["title"] !== undefined ? _data["title"] : <any>null;
      this.status = _data["status"] !== undefined ? _data["status"] : <any>null;
      this.detail = _data["detail"] !== undefined ? _data["detail"] : <any>null;
      this.instance = _data["instance"] !== undefined ? _data["instance"] : <any>null;
      if (_data["errors"]) {
        (<any>this).errors = {} as any;
        for (let key in _data["errors"]) {
          if (_data["errors"].hasOwnProperty(key))
            (<any>(<any>this).errors)![key] = _data["errors"][key] !== undefined ? _data["errors"][key] : [];
        }
      } else {
        (<any>this).errors = <any>null;
      }
    }
  }

  static fromJS(data: any): ValidationProblemDetails {
    data = typeof data === "object" ? data : {};
    let result = new ValidationProblemDetails();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    for (var property in this) {
      if (this.hasOwnProperty(property)) data[property] = this[property];
    }
    data["type"] = this.type !== undefined ? this.type : <any>null;
    data["title"] = this.title !== undefined ? this.title : <any>null;
    data["status"] = this.status !== undefined ? this.status : <any>null;
    data["detail"] = this.detail !== undefined ? this.detail : <any>null;
    data["instance"] = this.instance !== undefined ? this.instance : <any>null;
    if (this.errors) {
      data["errors"] = {};
      for (let key in this.errors) {
        if (this.errors.hasOwnProperty(key))
          (<any>data["errors"])[key] = this.errors[key] !== undefined ? this.errors[key] : <any>null;
      }
    }
    return data;
  }
}

export interface IValidationProblemDetails {
  type?: string | null;
  title?: string | null;
  status?: number | null;
  detail?: string | null;
  instance?: string | null;
  errors?: { [key: string]: string[] } | null;

  [key: string]: any;
}

export class ApiException extends Error {
  override message: string;
  status: number;
  response: string;
  headers: { [key: string]: any };
  result: any;

  constructor(
    message: string,
    status: number,
    response: string,
    headers: { [key: string]: any },
    result: any
  ) {
    super();

    this.message = message;
    this.status = status;
    this.response = response;
    this.headers = headers;
    this.result = result;
  }

  protected isApiException = true;

  static isApiException(obj: any): obj is ApiException {
    return obj.isApiException === true;
  }
}

function throwException(
  message: string,
  status: number,
  response: string,
  headers: { [key: string]: any },
  result?: any
): any {
  if (result !== null && result !== undefined) throw result;
  else throw new ApiException(message, status, response, headers, null);
}

function isAxiosError(obj: any | undefined): obj is AxiosError {
  return obj && obj.isAxiosError === true;
}
